import { LandlordTenantPortalPropertyBannerDetails } from "components/property-banner-image/landlord-tenant-portal-property-banner-details";
import { getGreeting } from "components/property-banner-image/property-banner-details";
import { useAuth } from "contexts/auth-provider";
import { DisplayBannerImage } from "modules/landlord-portal/components/display-banner-image";
import { PropertyCountNumbers } from "modules/landlord-portal/components/property-count-numbers";
import type { TenancyAgreementSummaryData } from "modules/landlord-portal/models/overview";

type LandlordBannerImageProps = {
  isLoading: boolean;
  propertySummary?: TenancyAgreementSummaryData;
};

export function LandlordBannerImage({
  isLoading,
  propertySummary,
}: LandlordBannerImageProps) {
  const { user } = useAuth();
  const currentHour = new Date().getHours();
  const greeting = getGreeting(currentHour);

  return (
    <LandlordTenantPortalPropertyBannerDetails
      isLoading={isLoading}
      title={`${greeting}, ${user?.given_name}!`}
      topLeftElement={<DisplayBannerImage user={user} />}
      subtitle={<PropertyCountNumbers propertySummary={propertySummary} />}
    />
  );
}
